import request from './request'
export function fetchList() {
  return request({
    url:'/rest/xwzx/tpyw',
    method:'get',
    // params:params
  })
}
export  function disabled() {
  return request({
    url:'/rest/visitordisabled/disableds',
    method:'get'
    
  })
}
export default {disabled,fetchList}



// WEBPACK FOOTER //
// ./src/http/getdata.js